import React from "react";
import { observer } from "mobx-react";
import { ColoredBlocks } from "../ItemDetailPageMain.styled";
import VariantIcon from "../../../../../../../images/common/notes-blue.svg";
import {
  CustomButton,
  CustomLabel,
  FlexContainer,
  ITableHeaders,
  TableWithHeaderButtons,
} from "@mindmemobile/mm-shared-global";
import {
  ProductAttributeInputModel,
  ProductAttributeMappingsInput,
  ProductAttributeWithOption,
  StandardPricingInputModel,
  SystemColorsModel,
} from "../../../../shared/models";
import { ItemsStore, RolesAndPermissionStore } from "../../../../shared/store";
import { GridNames } from "../../../../shared/enums";
import EditIcon from "../../../../../../../images/products/edit-blue.svg";
import { TableGrid } from "../../../../shared/components";

type Props = {
  attributes: ProductAttributeInputModel;
  standardPricing?: StandardPricingInputModel | null;
  itemStore: ItemsStore;
  onClickEditVariant: (index: number) => void;
  rolesAndPermissionStore: RolesAndPermissionStore;
};

type IAttributeOption = {
  attributeId: string;
  optionId: string;
};

class ItemVariantsGrid extends React.Component<Props> {
  get attriburtes() {
    return this.props.attributes;
  }

  get attributeMappings() {
    const mappings = this.attriburtes.options.map((option) => {
      return option.attributeMappings || [];
    });
    const validMappings = mappings.filter((x) => x.length > 0);
    const combinedMappings = validMappings.reduce(
      (acc, val) => acc.concat(val),
      []
    );
    const uniqueMappings: IAttributeOption[] = [];
    combinedMappings.forEach((up) => {
      if (!uniqueMappings.some((x) => x.attributeId === up.attributeId)) {
        uniqueMappings.push(up);
      }
    });

    const data: ProductAttributeWithOption[] = [];
    uniqueMappings.forEach((mapping) => {
      const dataToDisplay = combinedMappings.find(
        (x) => x.attributeId === mapping.attributeId //&& x.optionId === mapping.optionId,
      );
      if (dataToDisplay) {
        data.push(dataToDisplay);
      }
    });

    return data;
  }

  getPrice(
    option: ProductAttributeInputModel,
    variant: ProductAttributeMappingsInput
  ) {
    if (variant.isRemoved) {
      return "-";
    }

    if (option.priceByVariant) {
      return `$${variant.price}`;
    }

    return this.props.standardPricing
      ? `$${this.props.standardPricing.price}`
      : "-";
  }

  onEdit = (id: string) => {
    if (!this.props.rolesAndPermissionStore.hasManagePermission("Edit")) return;
    const index = this.attriburtes.options.findIndex(
      (option) => option.id === id
    );
    if (index !== -1) {
      this.props.onClickEditVariant(index);
    }
  };

  get columns() {
    const columns: ITableHeaders<ProductAttributeMappingsInput>[] = [
      {
        dataKey: "isRemoved",
        title: "Status",
        onCellRender: (data: ProductAttributeMappingsInput) => {
          const colors = data.isRemoved
            ? SystemColorsModel.lightGreyColors()
            : SystemColorsModel.ligthGreenColors();
          return (
            <CustomButton
              bgColor={colors.bgColor}
              color={colors.color}
              className="status-btn"
            >
              {data.isRemoved ? "Inactive" : "Active"}
            </CustomButton>
          );
        },
      },
      {
        dataKey: "name",
        title: "Name",
        className: "table-col-30",
        cellClassName: "table-col-30",
        onCellRender: (data: ProductAttributeMappingsInput) => {
          return <CustomLabel color="#556BB8">{data.name}</CustomLabel>;
        },
      },
      {
        dataKey: "price",
        title: "Price",
        onCellRender: (data: ProductAttributeMappingsInput) => {
          return this.getPrice(this.attriburtes, data);
        },
      },

      {
        dataKey: "name",
        title: "Actions",
        className: "text-center",
        onCellRender: (data: ProductAttributeMappingsInput) => {
          return (
            <div className="text-center" onClick={() => this.onEdit(data.id)}>
              <img src={EditIcon} className="blue-dots" />
            </div>
          );
        },
      },
    ];

    if (this.attriburtes.showOnHand)
      columns.splice(3, 0, {
        dataKey: "onHand",
        title: "On Hand",
        className: "table-col-5 text-center",
        cellClassName: "table-col-5 text-center",
        onCellRender: (data: ProductAttributeMappingsInput) => {
          return (
            <CustomLabel color="#556BB8" textAlign="center">
              {data.onHand}
            </CustomLabel>
          );
        },
      });

    const dynamicColumns: ITableHeaders<ProductAttributeMappingsInput>[] = [];
    this.attributeMappings.forEach((mapping) => {
      dynamicColumns.push({
        dataKey: "attributeMappings",
        title: mapping.attributeName,
        onCellRender: (data: ProductAttributeMappingsInput) => {
          const option = data.attributeMappings.find(
            (x) => x.attributeId === mapping.attributeId // && x.optionId === mapping.optionId,
          );
          if (option?.valueType === "Color") {
            return (
              <div key={mapping.optionId}>
                <CustomLabel>
                  <FlexContainer alignItems="center" spacing={9}>
                    <ColoredBlocks bgColor={option.color?.rgba} />
                    {option.optionName}
                  </FlexContainer>
                </CustomLabel>
              </div>
            );
          }
          return <div key={option?.optionId}>{option?.optionName || ""}</div>;
        },
      });
    });
    columns.splice(2, 0, ...dynamicColumns);
    return columns;
  }
  render() {
    return (
      <>
        <TableGrid
          wrapperClassName="table-with-header-btns "
          data={this.attriburtes.options}
          headers={this.columns}
          tableHeader={
            <TableWithHeaderButtons
              icon={VariantIcon}
              title="Variants"
              totalItems={this.attriburtes.options.length}
            />
          }
          totalItemCount={this.attriburtes.options.length}
          cellSpacing={20}
          name={GridNames.Item}
        />
        {/* {true && (
                  <VariantEditPopUp
                      itemStore={this.props.itemStore}
                      onCloseVariantEditPopup={() => {}}
                      productName={this.props.itemStore.selectedProduct?.detailSection.name || ''}
                  />
              )} */}
      </>
    );
  }
}

export default observer(ItemVariantsGrid);
